export default __webpack_public_path__ + "static/media/welcome-4.f461813e.png";